import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()(() => ({
  cardContent: {
    padding: 0,
    margin: 0,
    overflowY: "auto",
  },
  tableStyle: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0 10px",
    marginTop: "10px",
  },
  rowCell: {
    padding: 0,
    border: "none",
  },
  rowContainer: {
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    backdropFilter: "blur(10px)",
    borderRadius: "16px",
    border: "1px solid rgba(0, 0, 0, 0.04)",
    padding: "16px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "hidden",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
      "& .hover-indicator": {
        opacity: 1,
      },
    },
  },
  hoverIndicator: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: "4px",
    background: "linear-gradient(to bottom, #25D366, #128C7E)",
    opacity: 0,
    transition: "opacity 0.3s ease",
  },
  rowProfileSection: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  avatar: {
    height: "48px",
    width: "48px",
    borderRadius: "12px",
    border: "1px solid rgba(0,0,0,0.06)",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
  },
  pageName: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "16px",
    color: "#1a1a1a",
  },
  wa_number: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "13px",
    color: "#666",
  },
  rowActionSection: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  actionButton: {
    borderRadius: "10px",
    padding: "8px 20px",
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "13px",
    textTransform: "none",
    transition: "all 0.2s ease",
  },
  connectBtn: {
    backgroundColor: "rgba(37, 211, 102, 0.08)",
    color: "#128C7E",
    "&:hover": {
      backgroundColor: "rgba(37, 211, 102, 0.15)",
    },
  },
  disconnectBtn: {
    backgroundColor: "rgba(227, 77, 89, 0.05)",
    color: "#E34D59",
    "&:hover": {
      backgroundColor: "rgba(227, 77, 89, 0.1)",
    },
  },
  disabledBtn: {
    backgroundColor: "#f5f5f5",
    color: "#999",
  },
  deleteIconButton: {
    color: "#999",
    padding: "8px",
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#E34D59",
      backgroundColor: "rgba(227, 77, 89, 0.05)",
    },
  },
  deleteIcon: {
    fontSize: "20px",
  },
  circularProgress: {
    color: "inherit",
    marginRight: "8px",
  },
}));

export default useStyle;
